import { render, staticRenderFns } from "./ScoreTrendChart.vue?vue&type=template&id=63612bea"
import script from "./ScoreTrendChart.vue?vue&type=script&lang=js"
export * from "./ScoreTrendChart.vue?vue&type=script&lang=js"
import style0 from "./ScoreTrendChart.vue?vue&type=style&index=0&id=63612bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports